interface Props {
  logged: number;
  contracted: number | null;
  pct: number | null;
}

/**
 * Compact "X / Y h" hours indicator with an inline progress bar. Amber fill
 * when ≥80% complete, red when over budget. Falls back to plain text if
 * contracted hours are unknown.
 */
export function HoursBar({ logged, contracted, pct }: Props): JSX.Element {
  if (contracted == null || contracted <= 0) {
    return <span className="d-tnum">{logged.toFixed(1)} h</span>;
  }
  const clamped = Math.max(0, Math.min(1, pct ?? logged / contracted));
  const over = (pct ?? logged / contracted) > 1;
  const warn = (pct ?? logged / contracted) >= 0.8;
  const fill = over ? 'var(--risk)' : warn ? 'var(--accent)' : 'var(--ok)';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 110 }}>
      <span className="d-tnum" style={{ fontSize: 13 }}>
        {logged.toFixed(1)} / {contracted.toFixed(1)} h
        <span style={{ color: 'var(--mute)', marginLeft: 6, fontSize: 12 }}>
          {Math.round(((pct ?? logged / contracted) * 100))}%
        </span>
      </span>
      <div
        style={{
          height: 4,
          width: '100%',
          background: 'rgba(10,21,40,0.08)',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${clamped * 100}%`,
            height: '100%',
            background: fill,
            transition: 'width 200ms ease',
          }}
        />
      </div>
    </div>
  );
}
